/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";

import { colors } from "@dotnet/telematics-design-system";

import { MenuAnchorEl, useMediaQueries } from "../../../shared";
import Menu from "../../Menu/Menu";
import { useStyles } from "../styles";

interface FilterMenuProps {
  isOpen: boolean;
  anchorEl: MenuAnchorEl;
  children: React.ReactNode;
  onClose: () => void;
  hasMoreFilters?: boolean;
  moreFiltersBreakPoint?: boolean;
}

const FilterMenu = ({
  isOpen,
  anchorEl,
  children,
  onClose,
  hasMoreFilters,
  moreFiltersBreakPoint
}: FilterMenuProps) => {
  const { t } = useTranslation();
  const { fromLg } = useMediaQueries();

  const { filterMenu, filterMenuInnerDiv } = useStyles({});

  const renderMenuTitle = () =>
    hasMoreFilters && (moreFiltersBreakPoint || fromLg)
      ? t("Filter##more filters")
      : t("Filter##table filters");

  return (
    <Menu
      data-testid="filter-menu"
      open={isOpen}
      onClose={onClose}
      anchorEl={anchorEl}
      slotProps={{ list: { variant: "menu" } }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center"
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center"
      }}
      css={css(filterMenu)}
    >
      <div css={css(filterMenuInnerDiv)}>
        <Typography
          variant="body2Medium"
          sx={{
            color: colors.gray700,
            marginBottom: "16px"
          }}
          component="div"
        >
          {renderMenuTitle()}
        </Typography>

        {children}
      </div>
    </Menu>
  );
};

export default FilterMenu;
